import React, {useEffect, useCallback, useState, useRef} from 'react'
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { v4 as uuid } from 'uuid';
import axios from 'axios';
import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';
import { AssessmentIcon, DocumentIcon, FolderIcon, VideoIcon } from '../../../assets/icons/iconshere';
import { LMSPlayVideo, LMSPlayQuiz, LMSPlayPDF, LMSPlayPPT} from './ContentFileViewer';
import LMSPlayYT from './LMSPlayYT';
import { humanReadable } from '../../../utils/useWindowDimensions';
import { defaultLogo } from '../../../env';

const Player = ({ playerContent, id, fileType, fetchPreviousSession}) => {

    const userData = useSelector((state) => state.userSlice);
    const isLoggedIn = userData.token.length > 0 ? true : false;
    const configData = useSelector((state) => state.configSlice);
    const [sessionId, setSessionId] = useState(null);
    const calledSessionApi = useRef(false);

    const getSession = useCallback(async() =>{
      try {
        if(calledSessionApi.current) return;

        calledSessionApi.current = true;
        const {data} = await axios.get(`${configData.config.API_URL}/api/2D/lms/Create/session/${id}`,  {
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type": "application/json",
          }});
   
         setSessionId(data.data.uuid);

      } catch (error) {
        console.log(error);
      }
    },[id]);

    useEffect(()=>{
       id && getSession();
    },[]);

    const updateSessionData = async(data) =>{
      try { 
        await axios.post(`${configData.config.API_URL}/api/2D/lms/update/session/${sessionId}`, data, {
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type": "application/json",
          }});
      } catch (error) {
        console.log(error);
      }finally{
        fetchPreviousSession();
      }
    }

  return (
    <>
      {sessionId &&
      <>
        { playerContent.type === "video" && <LMSPlayVideo playerContent= {playerContent} onUpdate={updateSessionData}  />}
        { playerContent.type === "document" && fileType === "pdf" && <LMSPlayPDF playerContent= {playerContent} onUpdate={updateSessionData}  />}
        { playerContent.type === "document" && (fileType === "ppt" || fileType === "pptx" ) &&<LMSPlayPPT playerContent= {playerContent} onUpdate={updateSessionData}  />}
        { playerContent.type === "quiz" && <LMSPlayQuiz playerContent= {playerContent} onUpdate={updateSessionData}  />}
        { playerContent.type === "youtube" && <LMSPlayYT playerContent= {playerContent} onUpdate={updateSessionData}  />}
       </>
       }
    </>
  )

}




export default Player;